import styled from 'styled-components';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';
import ButtonOutline from 'components/buttons/ButtonOutline/styles';

export const BulkExportContainer = styled.div`
  position: relative;
  width: 520px;
  max-width: 100%;
  padding: 24px;
  font-family: 'Poppins', sans-serif;

  @media (max-width: 599px) {
    width: 100%;
    padding: 20px 16px;
  }
`;

export const BulkExportTitle = styled.h2`
  margin: 0 32px 8px 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  color: #2f3d48;
`;

export const BulkExportText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #7b8494;

  strong {
    font-weight: 500;
    color: #2f3d48;
  }
`;

export const BulkExportLabel = styled.label`
  display: block;
  margin: 20px 0 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #2f3d48;
`;

// Overrides the shared Say2EatDrop look for full-width stacked fields.
export const BulkExportField = styled.div`
  .Say2EatDrop {
    .MuiOutlinedInput-root {
      border-color: #e4e6ec;
      border-radius: 8px;
    }

    .MuiSelect-select,
    &.DropPeriod .MuiSelect-select {
      padding: 13px 44px 13px 16px !important;
      font-size: 14px;
      line-height: 20px;
      color: #2f3d48;
      text-indent: 0;
    }

    &.DropPeriod .MuiInputLabel-outlined,
    &.DropPeriod .MuiInputLabel-outlined.MuiInputLabel-shrink {
      transform: translate(16px, 14px) scale(1);
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      color: #2f3d48;
      pointer-events: none;
    }

    .MuiSelect-icon {
      right: 12px;
    }
  }
`;

export const BulkExportSentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #e8f7ef;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const BulkExportSubject = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 12px 16px;
  border: 1px solid #e4e6ec;
  border-radius: 8px;
  background-color: #f7f8fa;
  text-align: left;
  word-break: break-word;

  span {
    display: block;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #7b8494;
  }

  p {
    margin: 2px 0 0;
    font-size: 14px;
    line-height: 20px;
    color: #2f3d48;
  }
`;

export const BulkExportRecipient = styled.div`
  margin-top: 16px;
  font-size: 12px;
  line-height: 18px;
  color: #7b8494;
  word-break: break-word;

  strong {
    font-weight: 600;
    color: #2f3d48;
  }
`;

export const BulkExportActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;

  .LoadingExportButton {
    width: 140px;
  }
`;

export const BulkExportCancel = styled(ButtonOutline)`
  min-width: 108px;
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
`;

export const BulkExportSend = styled(ButtonPrimary)`
  min-width: 140px;
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
  box-shadow: none;

  &.disabled {
    background-color: #f2f3f5;
    color: #a4aab6;
    &::before,
    &::after {
      display: none;
    }
  }
`;

export const BulkExportSentBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${BulkExportTitle} {
    margin: 16px 0 8px;
  }

  ${BulkExportText} + ${BulkExportText} {
    margin-top: 8px;
  }

  ${BulkExportActions} {
    justify-content: center;
  }
`;
